import(/* webpackMode: "eager" */ "/app/apps/store/src/modules/delivery/pages/deliveryPage/DeliveryPage.tsx");
import(/* webpackMode: "eager" */ "/app/apps/store/src/shared/components/scrollUp/ScrollUp.tsx")